/* eslint-disable @typescript-eslint/no-unused-vars */
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import React, { useState } from "react";
import uuid from "react-uuid";
import { Text, Button } from "@mantine/core";
import AvatarWithLink from "../ui/avatar/Avatar";
import Pill from "../ui/badges/Pill";
import Trait from "./Trait";

type Props = {
  source: string,
  data: any,
  edit?:boolean,
};

const TraitSource = ({ source, data, edit = false }: Props) => {
  const [showAllTraits, setShowAllTraits] = useState(false);
  const entries = Object.entries(data);
  const displayedEntries = showAllTraits ? entries : entries.slice(0, 5);
  
  return (
    <div className="flex flex-wrap gap-x-[12%] gap-y-5">
      <Text truncate className="w-full text-xs mb-1 uppercase text-gray-500">
        {source}
        {" "}
        traits
      </Text>
      {displayedEntries.map(([key, value]: any) => {
        if (value?.type === "user") {
          return (
            <Trait title={value?.display_name} key={uuid()}>
              <AvatarWithLink
                name={value?.name}
                img={value?.image}
                size="sm"
                rounded
              />
            </Trait>
          );
        }

        if (value?.type === "badge") {
          return (
            <Trait title={value?.display_name} key={uuid()}>
              <Pill
                text={value.val}
                onClick={() => {}}
                color="red"
                size="md"
              />
            </Trait>
          );
        }

        return (<Trait key={uuid()} title={value?.display_name}>{value?.val ? value.val : (<span className="mt-2 h-[5px] bg-gray-200 w-[40px] rounded-lg" />)}</Trait>);
      })}
      
      {entries.length > 5 && (
        <div className="w-full flex justify-start mt-2">
          <Button 
            variant="subtle" 
            size="xs" 
            compact 
            onClick={() => setShowAllTraits(!showAllTraits)}
            c="dimmed"
          >
            {showAllTraits ? 'See less' : `See more (${entries.length - 5})`}
          </Button>
        </div>
      )}
    </div>
  );
};

export default TraitSource;
